'use client'

import useDatadog from '@/lib/hooks/use-datadog'

const DatadogInitializer = () => {
  useDatadog()
  return null
}

export default DatadogInitializer
